export default __webpack_public_path__ + "static/Colas-Rail-logo-baseline-noir-no-text-3ffb4ec1a34b2e0661f068ca0d00efb7.png";